import {
    CREATE_NEW_USER,
    DELETE_USER,
    UPDATE_USER_DETAIL,
    GET_USER_DETAIL,
    GET_USER_LIST,
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    SHOW_MESSAGE,
} from '../ActionTypes'
import JwtAxios from "../../apiServices";
import {
    CREATE_USER_ENDPOINT,
    DELETE_USER_ENDPOINT,
    EDIT_USER_ENDPOINT,
    GET_USERS_ENDPOINT
} from "../../apiServices/API_ENDPOINTS";
import HandleNotification from "../../common/Notification";

export const onGetUserList = (page, per_page, name, user_status) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .get(`${GET_USERS_ENDPOINT}`, {
                params: {
                    page: page,
                    per_page: per_page,
                    ...(name && { name: name }),
                    ...(user_status && { user_status: 'Active' }),
                },
            })
            .then((data) => {
                if (data?.data?.code === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: GET_USER_LIST, payload: data.data.data});
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
            });
    };
};

export const onGetUserDetails = (userId) => {

    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .get(`api/users/${userId}/edit`)

            .then((data) => {
                if (data?.data?.code === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: GET_USER_DETAIL, payload: data.data});
                    dispatch({
                        type: SHOW_MESSAGE,
                        payload: "User Updated Successfully",
                    });
                    // HandleNotification('success', 'bottomRight', 'User Account updated Successfully!', null)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                    // HandleNotification('success', 'bottomRight', 'Something went wrong!', null)
                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
            });
    };
};

export const onCreateUser = (user) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .post(`${CREATE_USER_ENDPOINT}`, user)
            .then((data) => {
                if (data?.data?.code === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: CREATE_NEW_USER, payload: data.data});
                    dispatch({
                        type: SHOW_MESSAGE,
                        payload: "User Created Successfully",
                    });
                    HandleNotification('success', 'bottomRight', data?.data?.message, null)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                    HandleNotification('error', 'bottomRight', data?.data?.message, null)

                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                HandleNotification('error', 'bottomRight', error?.message, null)
            });
    };
};

export const onUpdateSelectedUser = (user) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .put(`${EDIT_USER_ENDPOINT}/${user.id}`, user)

            .then((data) => {
                if (data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: UPDATE_USER_DETAIL, payload: data.data});
                    dispatch({
                        type: SHOW_MESSAGE,
                        payload: "User Updated Successfully",
                    });
                    HandleNotification('success', 'bottomRight', data?.data?.message, null)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                    HandleNotification('error', 'bottomRight', data?.data?.message, null)

                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                HandleNotification('error', 'bottomRight', error?.message, null)
            });
    };
};

export const onDeleteUser = (user) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .delete(`${DELETE_USER_ENDPOINT}/${user['id']}`)
            .then((data) => {
                if (data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: DELETE_USER, payload: data.data});
                    dispatch({
                        type: SHOW_MESSAGE,
                        payload: "Deleted user Successfully",
                    });

                    HandleNotification('success', 'bottomRight', data?.data?.message, null)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                    HandleNotification('error', 'bottomRight', data?.data?.message, null)

                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                HandleNotification('error', 'bottomRight', error?.message, null)
            });
    };
};



